import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { SupportFab } from './SupportFab';
import { PromoPopup } from './PromoPopup';
import { NewsletterSection } from './Newsletter';
import { useSite } from '@/context/SiteContext';

export const PublicLayout = () => {
  const { pathname } = useLocation();
  const { loading, error, site } = useSite();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  // Titles/meta are owned by the per-page <Seo /> (react-helmet-async); here we only enforce the canonical host.

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center" data-testid="site-loading">
        <img src="/logos/bukit-ancak.png" alt="Bukit Ancak" className="h-16 w-auto animate-pulse" />
      </div>
    );
  }
  if (error) {
    return (
      <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-4 px-6 text-center" data-testid="site-error">
        <img src="/logos/bukit-ancak.png" alt="Bukit Ancak" className="h-14 w-auto" />
        <p className="text-muted-foreground">{error}</p>
        <button type="button" className="btn-outline" onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <NewsletterSection />
      <Footer />
      <SupportFab />
      <PromoPopup />
    </div>
  );
};
